import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  z-index: 1;\n  color: var(", ");\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n\n  width: ", ";\n  height: ", ";\n\n  ", "\n\n  &::before {\n    content: '';\n    position: absolute;\n    width: ", ";\n    height: ", ";\n\n    line-height: 0;\n    text-align: center;\n\n    background-color: var(\n      ", "\n    );\n\n    border-color: ", ";\n    border-style: solid;\n    border-width: ", ";\n    border-radius: ", ";\n\n    transform: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectTypography } from '../../utils/injectTypography';

var getBadgesBoundBoxSize = function getBadgesBoundBoxSize(props) {
  return props.displayCount ? '24px' : '8px';
};

var getBadgesSize = function getBadgesSize(props) {
  if (props.displayCount) {
    return '24px';
  } else {
    switch (props.variant) {
      case 'negative':
        return '0px';

      case 'informative':
      case 'notice':
      case 'positive':
      default:
        return '8px';
    }
  }
}; // function getBadgesColor (props: StyledBadgeProps) {}


var getBadgesColor = function getBadgesColor(props) {
  switch (props.variant) {
    case 'positive':
      return props.theme.colors.ui.success;

    case 'notice':
      return props.theme.colors.ui.pending;

    case 'negative':
      return 'transparent';

    case 'informative':
    default:
      return props.theme.colors.ui.highlight.primary;
  }
};

var getBadgesCorners = function getBadgesCorners(props) {
  if (props.displayCount) {
    return '100%';
  } else {
    switch (props.variant) {
      case 'notice':
      case 'negative':
        return '0%';

      case 'informative':
      case 'positive':
      default:
        return '100%';
    }
  }
};

var getBadgesTransform = function getBadgesTransform(props) {
  if (props.displayCount) {
    return 'rotate(0deg)';
  } else {
    switch (props.variant) {
      case 'notice':
        return 'rotate(45deg)';

      case 'negative':
        return 'translateY(-0.5px)';

      case 'informative':
      case 'positive':
      default:
        return '';
    }
  }
};

var getBadgesBorderWidth = function getBadgesBorderWidth(props) {
  if (props.displayCount) {
    return '0px';
  } else {
    switch (props.variant) {
      case 'negative':
        return '0px 5px 9px 5px';

      case 'informative':
      case 'positive':
      case 'notice':
      default:
        return '0px';
    }
  }
};

var getBadgesBorderColor = function getBadgesBorderColor(props) {
  if (props.displayCount) {
    return 'transparent';
  } else {
    switch (props.variant) {
      case 'negative':
        return "transparent transparent var(".concat(props.theme.colors.ui.error, ") transparent");

      case 'informative':
      case 'positive':
      case 'notice':
      default:
        return 'transparent';
    }
  }
};

export var StyledBadgeContainer = styled.span(_templateObject(), function (props) {
  return getBadgesBoundBoxSize(props);
}, function (props) {
  return getBadgesBoundBoxSize(props);
}, injectSpacing('margin'), function (props) {
  return getBadgesSize(props);
}, function (props) {
  return getBadgesSize(props);
}, function (props) {
  return props.displayCount ? props.theme.colors.ui.highlight.primary : getBadgesColor(props);
}, function (props) {
  return getBadgesBorderColor(props);
}, function (props) {
  return getBadgesBorderWidth(props);
}, function (props) {
  return getBadgesCorners(props);
}, function (props) {
  return getBadgesTransform(props);
});
export var StyledBadgeCount = styled.span(_templateObject2(), function (props) {
  return props.theme.colors.ui.inverted;
}, function (props) {
  return injectTypography(props, props.count && props.count <= 100 ? 'copy2' : 'copy3');
});